export default "__VITE_ASSET__d1e20474__"